import { render } from "./form-title.vue?vue&type=template&id=62afdea6"
import script from "./form-title.vue?vue&type=script&lang=js"
export * from "./form-title.vue?vue&type=script&lang=js"

import "./form-title.vue?vue&type=style&index=0&id=62afdea6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__